import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="Page Not Found | Jisedai"
        description="The page you were looking for could not be found."
        url="https://www.jisedai.africa/404"
      />

      <section className="relative min-h-screen bg-black text-white px-6 py-24 overflow-hidden flex items-center">
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-16 left-1/4 h-64 w-64 rounded-full bg-yellow-400/10 blur-3xl" />
          <div className="absolute bottom-16 right-1/4 h-72 w-72 rounded-full bg-yellow-500/10 blur-3xl" />
        </div>

        <div className="relative max-w-3xl mx-auto text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-yellow-400/80">
            404
          </p>
          <h1 className="mt-4 text-4xl md:text-6xl font-bold text-yellow-400 drop-shadow-[0_0_14px_rgba(250,204,21,0.25)]">
            This page could not be found
          </h1>
          <p className="mt-6 text-lg md:text-xl text-gray-300 leading-relaxed">
            The link may be outdated, or the page may have moved. You can head
            back home or continue to the latest Jisedai updates.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/"
              className="rounded-xl bg-yellow-400 px-8 py-4 font-semibold text-black transition hover:bg-yellow-300"
            >
              Go Home
            </Link>
            <Link
              to="/blog"
              className="rounded-xl border border-yellow-400 px-8 py-4 font-semibold text-yellow-300 transition hover:bg-yellow-400 hover:text-black"
            >
              Visit the Blog
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
